import React, { useContext } from 'react';

import { LayoutContext } from '../../context/layoutContext';
import { TextBox } from '../../styles/globalStyles';

const LinkBtn = ({ goPage, title }) => {
  const { matchese } = useContext(LayoutContext);
  return (
    <TextBox onClick={goPage} color='#aaaaaa' fontSize='14px' cursor='pointer'>
      {title && <b className='blue'>{title}</b>}
      {title && `검색 결과 `}
      {title && matchese && `더보기 `}
      {matchese ? '〉' : '더보기  〉'}
    </TextBox>
  );
};

export default LinkBtn;
